import { resolveCompare } from "../../../Components/Filters/DashboardFiltersBlock/resolveCompare"
import { RANGE_PRESETS } from "../../../Components/Filters/DropdownDateBlock/periodLabel"

const ISO_DATE = "YYYY-MM-DD"

// A picked preset ("Last 4 weeks") always ends today (DAA-2-14). The date dropdown stores it as the
// dates of the day it was picked, so a filter persisted from an earlier visit is re-dated from its
// preset id, and its compare re-checked against the new dates (DAA-2-17): "Previous month" is not
// offered for a 31-day Month to date. A custom range and All time are kept as they are.
export const withCurrentPreset = (filters) => {
  const preset = RANGE_PRESETS.find((candidate) => candidate.id === filters.__preset_period)

  if (!preset || preset.value) return filters

  const [from, to] = preset.range()
  const period = { type: "custom", period: [from.format(ISO_DATE), to.format(ISO_DATE)] }

  return { ...filters, period, compare: resolveCompare(filters.compare, period) }
}
